<template>
  <v-card class="h-full">
    <ODialogBar title="Cadastro" no-close>
      <v-spacer />
      <v-btn icon @click="() => $refs.dialog.open(row.id)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </ODialogBar>
    <v-card-text>
      <div v-if="row.deletedAt != null" class="tag red mb-4">
        Desativado em {{ row.deletedAt | moment('DD/MMM/YYYY HH:mm') }}
      </div>

      <OCapCont label="Nome" class="mb-4">
        {{ row.name }}
      </OCapCont>

      <OCapCont label="Cliente" class="mb-4">
        {{ row.customer && row.customer.label }}
      </OCapCont>

      <OCapCont label="Observações" class="mb-4">
        {{ row.description }}
      </OCapCont>
    </v-card-text>

    <OSimpleEditDialog
      ref="dialog"
      title="Editar Centro de Custo"
      :fetchData="fetchData"
      :doSave="doSave"
      strings="centro de custo;o"
      @reload="$emit('reload')"
    >
      <template v-slot="{ row }">
        <v-form ref="theForm" class="d-flex flex-column pa-3 children-pa-3">
          <OTextField label="Nome" v-model="row.name" :rules="[isSet]" />
          <OAutocomplete
            v-model="row.customerId"
            label="Cliente"
            placeholder="Selecione..."
            :items="customers"
            :rules="[isSet]"
          />
          <OTextarea v-model="row.description" label="Observações" />
        </v-form>
      </template>
    </OSimpleEditDialog>
  </v-card>
</template>

<script>
import OSimpleEditDialog from 'oderon-vue/cpts/dialogs/OSimpleEditDialog.vue'
import { Customer, CostCenter } from '@/models'
import { splitAndSort } from '../../clients/operations/operation-utils.js'

import { isSet } from 'oderon-vue/utils.js'

export default {
  components: { OSimpleEditDialog },
  props: {
    row: { required: true }
  },
  data() {
    return { isSet, customers: [] }
  },
  methods: {
    async fetchData(id) {
      let allCustomers = await Customer.findAll({ includeInactive: true })
      this.customers = splitAndSort(allCustomers)

      return await CostCenter.findById(id)
    },
    async doSave(row) {
      return await CostCenter.save(row)
    }
  }
}
</script>

<style></style>
